import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { isAppReady } from '../../store/reducers';
import { auth } from '../../store/auth/auth.selectors';
import { filter, withLatestFrom, switchMap, map } from 'rxjs/operators';
import * as actions from '../../store/actions';

/**
 * Guards routes that should only be accessed by anonymous users
 */
@Injectable()
export class UnauthenticatedGuard  {
  private appReady: Observable<boolean>;
  private authenticated: Observable<boolean>;
  constructor(private store: Store<any>) {
    this.appReady = this.store.select(isAppReady);
    this.authenticated = this.store.select(auth.getLoggedIn);
  }

  public canActivate(): Observable<boolean> {
    return this.appReady.pipe(
      filter((ready) => ready),
      withLatestFrom(this.authenticated),
      map(([ready, authenticated]) => {
        if (authenticated) {
          this.store.dispatch(
            actions.NavigateAction({
              path: ['/'],
              reason: 'User is already authenticated',
            })
          );
          return false;
        }
        return true;
      })
    );
  }
}
